export class Tabs {
  static selector = "[data-component=tabs]"

  constructor(el) {
    this.root = el
    this.tabBtns = Array.from(el.querySelectorAll("ul[role=tablist] li"))
    this.tabContents = Array.from(el.querySelectorAll(".tabs__tab-content"))

    this.setup()
  }

  onSelectTab = ev => {
    ev.preventDefault()
    const tabId = ev.target.getAttribute("aria-controls")
    if (document.startViewTransition) {
      document.startViewTransition(() => this.selectTab(tabId))
    } else {
      this.selectTab(tabId)
    }
  }

  selectTab = tabId => {
    this.tabBtns.forEach(btn => {
      if (btn.getAttribute("aria-controls") === tabId) {
        btn.setAttribute("aria-selected", "true")
      } else {
        btn.setAttribute("aria-selected", "false")
      }
    })
    this.tabContents.forEach(tabContent => {
      if (tabContent.id === tabId) {
        tabContent.dataset.active = ""
      } else {
        tabContent.removeAttribute("data-active")
      }
    })
  }

  setup() {
    this.tabBtns.forEach(x => x.addEventListener("click", this.onSelectTab))
  }
}
